import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { checkManagerCenterAccess } from '../../services/workforceIntelligenceService';
import { logout } from '../actions/authActions';

export interface ManagerCenterAccessState {
  hasAccess: boolean;
  isChecked: boolean;
  isLoading: boolean;
}

const initialState: ManagerCenterAccessState = {
  hasAccess: false,
  isChecked: false,
  isLoading: false,
};

export const fetchManagerCenterAccess = createAsyncThunk(
  'managerCenterAccess/fetch',
  async () => checkManagerCenterAccess(),
);

const managerCenterAccessSlice = createSlice({
  name: 'managerCenterAccess',
  initialState,
  reducers: {
    resetManagerCenterAccess: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManagerCenterAccess.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchManagerCenterAccess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isChecked = true;
        state.hasAccess = action.payload;
      })
      .addCase(fetchManagerCenterAccess.rejected, (state) => {
        state.isLoading = false;
        state.isChecked = true;
        state.hasAccess = false;
      })
      .addCase(logout.fulfilled, () => initialState);
  },
});

export const { resetManagerCenterAccess } = managerCenterAccessSlice.actions;
export default managerCenterAccessSlice.reducer;
